export default "__VITE_ASSET__CWIACtm3__ 480w, __VITE_ASSET__CZ4zmY1l__ 768w, __VITE_ASSET__penhxSYx__ 1200w, __VITE_ASSET__Ci6XCWz___ 1600w";